import { useEffect, useState, Fragment, useContext, useRef } from "react";
import { useParams } from "react-router-dom";
import {baseURL, imageBaseURL, imageBaseLehguURL, userUploadURL, audioBaseURL, videoBaseURL, lerneinheitenOverviewPageID,
    categoryToIconMapper,
    lehguPlusPageID,
    jwtName
} from "../../constants"

import Cookies from 'universal-cookie';
import { Link, useNavigate } from 'react-router-dom';
import ReactPlayer from 'react-player'
import {PageTreeContext} from "../../context/pageTreeContext"
import { isNeitherNullNorUndefined, containsOnlyNumbers } from "../../utils/functions";
import FlipCard from "../FlipCard/FlipCard_alt";
import SCQuiz from "../multipleChoice/SCQuiz";
import MCQuiz from "../multipleChoice/MCQuiz";

import DnD from "../dnd/dnd";
import DnDSmall from "../dnd/DnDSmall"
import DragAndOrder from "../dnd/dragAndOrder";
import DragAndOrderSmall from "../dnd/dragAndOrderSmall";
import "../../style/page.css";
import TitleIcon from "./TitleIcon";
import {postRequest, checkImage } from "../../utils/requestFunctions";
import {handleFavoritesChange} from "../Favorites/utils/favoritesInteraction";
import {parseMultipleChoiceQuiz, parseDragnDropQuiz, parseDragnOrderQuiz } from "./utils/parsingFuntions"
import {fixLinks, processHtmlString, removeSpecialChars, adjustListTags, pruneTypo3AddedTags, containsButtons, adjustButtons, cutButtons } from "./utils/htmlAdjustments"
import {contentIntroPageID, techIntroPageID, erfahrenSieMehrPageID} from "../../constants"
import Footer from "../Footer"
import SafeImage from "./safeImage"
import {staticPagesIDs, staticPagesMapping } from "./staticPages/index"

// TODO: break up code into files


export default function Page() {
    const routeParams = useParams();
    const cookies = new Cookies()
    const navigate = useNavigate();
    const [pageContent, setPageContent] = useState()
    // page's position in pageTree including next and previous pageIDs
    const [pageNavigationInfo, setPageNavigationInfo] = useState()
    const [isFavoritePage, setIsFavoritePage] = useState(false)
    const [isFavoriteExercise, setIsFavoriteExercise] = useState(false)
    const [containsManuallySetButtons, setContainsManuallySetButtons] = useState(false)
    const pageTreeContextValue = useContext(PageTreeContext);
    const [actualTitle, setActualTitle] = useState("")

    const [headerExists, setHeaderExists] = useState(true)

    const windowWidth = useRef(window.innerWidth);


    async function getPageContestRequestAndSet(jwt){
        try {
            // params: postRequest(jwt, url, data)
            const response = await postRequest(jwt, baseURL + "lerneinheiten/page/" + routeParams.id, "")
            if(response.data){
                // get rid of weiter/zurück buttons within bodytext
                if(containsButtons(response.data)){
                    setContainsManuallySetButtons(true)
                    setPageContent(adjustButtons(response.data))
                } else {
                    setContainsManuallySetButtons(false)
                    setPageContent(response.data)
                }
                setIsFavoritePage(response.data.isFavoritePage)
                setIsFavoriteExercise(response.data.isFavoriteExercise)

                // get actual page title from header of first content element
                if(response.data.contents.length > 0){
                    if(response.data.contents[0].header){
                        setActualTitle(response.data.contents[0].header)
                    }
                }
            }  
        } catch (error) {
            console.error("error", error.message);
        }
    }

    async function getPageContent() {
        const jwt = cookies.get(jwtName)
        if(!jwt){
            // login not required for "Erfahren Sie mehr" page
            if(parseInt(routeParams.id) === erfahrenSieMehrPageID){
                // jwt is null => backend makes exception. Kinda bad practice //TODO
                await getPageContestRequestAndSet(jwt)
            } else {
                navigate('/')
            }
        }else {
            await getPageContestRequestAndSet(jwt)
        }
    }



    async function getPageNavigationInfo() {
        // get info from context where it is processed from pageTree
        const info = pageTreeContextValue.getPageNavigationInfo(routeParams.id)     // OK
        if(isNeitherNullNorUndefined(info)){
            setPageNavigationInfo(info)
            // redirects:
            if(info.subChapterID == null){
                // is starting page of a Lerneinheit, redirect to first subChapter
                if(isNeitherNullNorUndefined(info.nextPageID)){
                    // exception for Lehgu Plus
                    if(parseInt(routeParams.id) !== lehguPlusPageID){
                        navigate("/lerneinheiten/page/" + info.nextPageID)
                    }
                } else {
                    navigate("/")
                }
            } else if(info.lerneinheitID === lehguPlusPageID && info.leafPageName === null){
                navigate("/lerneinheiten/page/" + info.nextPageID)
                console.log(info)
                // special case: in Lehgu Plus redirect to first subpage when visiting subChapter (Leitfrage)

            }
        } else {
            navigate("/")
        }
    }



    useEffect(() => {
        if(parseInt(routeParams.id)  === techIntroPageID || parseInt(routeParams.id) === contentIntroPageID){
            pageTreeContextValue.amILoggedIn()
            getPageContent()
        } else {
            pageTreeContextValue.amILoggedIn()
            getPageContent()
            if(isNeitherNullNorUndefined(pageTreeContextValue.getPageTree())){
                getPageNavigationInfo()
            }
            pageTreeContextValue.changeIsBreadcrumbsVisible(true)
            // TODO: when click on breadcrumb there is no pageNavigationInfo !!!!!!!!!!!!!!!!!
        }
    }, [])


//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    useEffect(() => {
        console.log("pageContent")
        console.log(pageContent)
    }, [pageContent])




    

    // rerender on navigation from page level 
    useEffect(() => {
        // scroll to top
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
        // redirect to "Erfahren Sie Mehr" without login
        if(parseInt(routeParams.id) === erfahrenSieMehrPageID){
            navigate("/info")
        } else if(parseInt(routeParams.id)  === techIntroPageID || parseInt(routeParams.id) === contentIntroPageID){
            pageTreeContextValue.amILoggedIn()
            getPageContent()
        } else {
            pageTreeContextValue.amILoggedIn()
        //    console.log("pageTree after route.params.id change: " , pageTreeContextValue.getPageTree())      // !!!! undefined
            if(parseInt(routeParams.id) === lerneinheitenOverviewPageID){
                navigate('/lerneinheiten')
            } else {
            getPageContent() 
            if(isNeitherNullNorUndefined(pageTreeContextValue.getPageTree())){       //TODO: reduce code of initialization in useEffects
                    getPageNavigationInfo()
                }        
            }
            pageTreeContextValue.changeIsBreadcrumbsVisible(true)
            // TODO: receive and set isFavorite status 
        }
    }, [routeParams.id])
 

    // replace received next & prev buttons with own navigation based on pageTree
    function navigateToNextPage(){
        if(isNeitherNullNorUndefined(pageNavigationInfo)){
            navigate('/lerneinheiten/page/' + pageNavigationInfo.nextPageID)
        //    console.log("navigate to  " + pageNavigationInfo.nextPageID)
        //    setPageContent(null)
        } else {
            console.log("ERROR no pageNavigationInfo")
        }
    }
    
    function navigateToPreviousPage(){
        if(isNeitherNullNorUndefined(pageNavigationInfo)){
            navigate('/lerneinheiten/page/' + pageNavigationInfo.previousPageID)
        //    console.log("navigate to  " + pageNavigationInfo.previousPageID)
            setPageContent(null)
        } else {
            console.log("ERROR no pageNavigationInfo")
        }
    }










    async function handleBookmarkClicked(){
        const jwt = cookies.get(jwtName)
        pageNavigationInfo && console.log("pageNavigationInfo.isExercisePage " + pageNavigationInfo.isExercisePage)
        console.log("isFavoriteExercise " + isFavoriteExercise)
        console.log("isFavoritePage " + isFavoritePage)

        if(jwt){
            if(pageNavigationInfo && pageNavigationInfo.isExercisePage){
                // set favoritePage false
                if(isFavoriteExercise){
                    await handleFavoritesChange(jwt, pageTreeContextValue.currentPageID, pageContent.title, 1, 0)
                    setIsFavoriteExercise(false)                
                } else {
                    await handleFavoritesChange(jwt, pageTreeContextValue.currentPageID, pageContent.title, 1, 1)
                    setIsFavoriteExercise(true)                
                }
            } else {
                // is not an exercise page
                if(isFavoritePage){
                    await handleFavoritesChange(jwt, pageTreeContextValue.currentPageID, pageContent.title, 0, 0)
                    setIsFavoritePage(false)
                } else {
                    await handleFavoritesChange(jwt, pageTreeContextValue.currentPageID, pageContent.title, 0, 1)  
                    setIsFavoritePage(true)               
                }
            }
        }
    }

    
    



    return (
        <div>
            {
            // a few pages are static. See ./staticPages
            // those are inhaltliche and technische Einführung and for some reason the pages with IDs 716 and 718. 
            // the data retrieval process fails for just these two pages. No clue why.
            // test here if we are on a static page to display the static content.
            // if not, then process and display content dynamically received from backend.
            }
            {staticPagesIDs.includes(parseInt(routeParams.id)) 
            ?
            <div className=" ">{staticPagesMapping[parseInt(routeParams.id)]}</div>
            :    
                // dynamic content page
                <div className="mainWithoutFooter ">
                {
                    // Page Title
                }
               {headerExists && <h1 className="pageTitle">
                    {pageNavigationInfo && pageNavigationInfo.category !== null && <img src={pageNavigationInfo.category[0] in categoryToIconMapper 
                        ? 
                        imageBaseURL + categoryToIconMapper[pageNavigationInfo.category[0]] 
                        :
                        ""} 
                        alt=""
                    />}
                    <div className="mr-1">{isNeitherNullNorUndefined(pageContent) && pageContent.title}</div>
                    {(parseInt(routeParams.id) !== techIntroPageID && parseInt(routeParams.id) !== contentIntroPageID && parseInt(routeParams.id) !== erfahrenSieMehrPageID) 
                        &&
                        <TitleIcon isFavoritePage={isFavoritePage} 
                                isExercisePage={pageNavigationInfo && pageNavigationInfo.isExercisePage} 
                                isFavoriteExercise={isFavoriteExercise}
                                handleBookmarkClicked={handleBookmarkClicked}
                        />
                    }
                </h1>}


                {
                    // Page Body
                }
                <div>
                    {pageContent !== null && typeof pageContent !== 'undefined' && typeof(pageContent.contents) !== 'undefined' 
                    ? 
                    pageContent.contents.map(element => {
                    return(
                        
                        // CONTENT PROCESSING
                        
                        <div className="pageContentsWrapper ">
                            {
                                // check for Quizzes
                                // necessary condition: content element has Typo3 content type "text"
                                // but actual text content (not syntactically enriched strings) will be processed at the very bottom seperately
                                //
                                // quiz types:
                                // "_MC_"       multiple choice
                                // "_dnd_"      drag and drop
                                // "_dno_"      drag and order
                            }
                            <div className="contentElement ">
                                {element.CType === "text" 
                                && (
                                        // check for multiple choice quiz
                                        pruneTypo3AddedTags(element.content).startsWith("_MC_") 
                                        ? 
                                        <div>
                                            {parseMultipleChoiceQuiz(element.content) 
                                            &&
                                            parseMultipleChoiceQuiz(element.content).correctAnswerIndeces.length > 1 
                                            ?
                                            <MCQuiz question={parseMultipleChoiceQuiz(element.content).question} 
                                                    answers={parseMultipleChoiceQuiz(element.content).answers} 
                                                    correctAnswers={parseMultipleChoiceQuiz(element.content).correctAnswerIndeces} 
                                                    correctMsg={parseMultipleChoiceQuiz(element.content).correctMsg}
                                                    wrongMsg={parseMultipleChoiceQuiz(element.content).wrongMsg}
                                                    height={parseMultipleChoiceQuiz(element.content).height}
                                            />
                                            :
                                            <SCQuiz question={parseMultipleChoiceQuiz(element.content).question} 
                                                    answers={parseMultipleChoiceQuiz(element.content).answers} 
                                                    correctAnswer={parseMultipleChoiceQuiz(element.content).correctAnswerIndeces} 
                                                    correctMsg={parseMultipleChoiceQuiz(element.content).correctMsg}
                                                    wrongMsg={parseMultipleChoiceQuiz(element.content).wrongMsg}
                                                    height={parseMultipleChoiceQuiz(element.content).height}
                                            />
                                            }
                                        </div>
                                        :
                                        // check for drag and drop quiz
                                        pruneTypo3AddedTags(element.content).startsWith("_dnd_") 
                                        ?   
                                        <div>
                                            {parseDragnDropQuiz(element.content) !== null
                                            && 
                                            <div>
                                                {windowWidth.current > 1000
                                                ?
                                                    <DnD title={parseDragnDropQuiz(element.content).title} 
                                                        originalDrags={parseDragnDropQuiz(element.content).drags} 
                                                        drops={parseDragnDropQuiz(element.content).drops} 
                                                        correctAnswer={parseDragnDropQuiz(element.content).correctAnswer} 
                                                        wrongAnswer={parseDragnDropQuiz(element.content).wrongAnswer}    
                                                    />
                                                :
                                                    <DnDSmall title={parseDragnDropQuiz(element.content).title} 
                                                        originalDrags={parseDragnDropQuiz(element.content).drags} 
                                                        drops={parseDragnDropQuiz(element.content).drops} 
                                                        correctAnswer={parseDragnDropQuiz(element.content).correctAnswer} 
                                                        wrongAnswer={parseDragnDropQuiz(element.content).wrongAnswer}    
                                                    />
                                                }
                                            </div>
                                            }
                                        </div>
                                        :
                                        // check for drag and order quiz
                                        pruneTypo3AddedTags(element.content).startsWith("_dno_") 
                                        &&
                                        <div>
                                            {parseDragnOrderQuiz(element.content) !== null
                                            &&
                                            <div>{windowWidth.current < 1000
                                                ?
                                                <DragAndOrderSmall title={parseDragnOrderQuiz(element.content).title} 
                                                    originalDrags={parseDragnOrderQuiz(element.content).drags} 
                                                    correctAnswer={parseDragnOrderQuiz(element.content).correctAnswer} 
                                                    wrongAnswer={parseDragnOrderQuiz(element.content).wrongAnswer}                                                         
                                                />
                                                :
                                                <DragAndOrder title={parseDragnOrderQuiz(element.content).title} 
                                                    originalDrags={parseDragnOrderQuiz(element.content).drags} 
                                                    correctAnswer={parseDragnOrderQuiz(element.content).correctAnswer} 
                                                    wrongAnswer={parseDragnOrderQuiz(element.content).wrongAnswer}                                                         
                                                />
                                                }
                                            </div>
                                            }
                                        </div>
                                    )
                                }
                            </div> 



                            {
                                // check for cards (Typo3 content type "card")
                            }
                            <div className="contentElement ">
                                {element.CType === "card" 
                                && (
                                        element.content == null 
                                        ? 
                                        <div> {  
                                    //TODO:  For some reason for every card entry there seems to be one with content null
                                    //    <div>
                                     //       <div>ERROR</div>
                                     //       <div>{JSON.stringify(element)}</div>
                                     //   </div>
                                    }</div>
                                     
                                        :
                                        (element.content.front !== "" && element.content.back !== "") &&
                                        <FlipCard front={element.content.front} back={element.content.back}/>
                                    )
                                }
                            </div> 



                            {
                                // check for Typo3 content type "textpic"
                                // treated as html
                            }
                            <div className="contentElement ">
                                {element.CType === "textpic" 
                                && (
                                        element.content == null 
                                        ? 
                                        <div>
                                            <div>ERROR</div>
                                            <div>{JSON.stringify(element)}</div>
                                        </div>
                                        :
                                        <div className="">
                          {              //    <div>TEXTPIC</div>
                                            // <div>{JSON.stringify(element)}</div>
                                        //    <div>image: {JSON.stringify(element.content[0].name)}</div>
                                        }
                                            <div className="bodyText" 
                                                dangerouslySetInnerHTML={{__html: element.content[0].text}}  
                                            />
                                        </div>
                                    )
                                }
                            </div> 





                            {
                                // check if content block is an array instead of string
                                // if it is just a string treat it as html
                                // if it is an array: check for media (mp3, mp4, jpg/png/svg)
                            }
                            <div className="contentElement ">{isNeitherNullNorUndefined(element.content) && typeof element.content !== "string" 
                                ?
                                isNeitherNullNorUndefined(element.content) 
                                && 
                                Array.isArray(element.content) 
                                ? 
                                element.content.map(asset => {
                                    if(asset.type){
                                       return (
                                        <div>

                                            {asset.extension === "mp3" 
                                                ? 
                                                <div className="contentElement ">
                                                    <audio controls src={audioBaseURL + asset.name}  ></audio>
                                                </div>
                                                : asset.extension === "mp4" 
                                                    ? 
                                                    <div className="videoPLayer">
                                                        <ReactPlayer url={videoBaseURL + asset.name} controls={true} />
                                                    </div>
                                                    : 
                                                    asset.extension === "jpg" || asset.extension === "png" || asset.extension === "svg"
                                                    ? 
                                                    <div className="lehguImage">
                                                    {<SafeImage src={imageBaseLehguURL + asset.name} altSources={[userUploadURL + asset.name, imageBaseURL + asset.name]}  /> 
                                         
                                                }
                                                    </div>
                                                    : <div>
                                                        {
                                                        //    Spinner
                                                        }
                                                        <div role="status">
                                                            <svg aria-hidden="true" class="w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                                                                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                                                            </svg>
                                                            <span class="sr-only">Loading...</span>
                                                        </div>
                                                        {
                                                        //    <div>{JSON.stringify(asset)}</div>
                                                        }
                                                        
                                                    </div>}
                                        </div>
                                    ) 
                                    }
                                    
                                })
                                :
                                <div>
                                    {
                                    //    element.content  
                                    }
                                </div>
                                :
                                // just text:
                                // double check that it isn't a quiz 
                                element.content !== null && typeof element.content !== 'undefined' && 
                                !pruneTypo3AddedTags(element.content).startsWith("_dnd_") &&
                                !pruneTypo3AddedTags(element.content).startsWith("_dno_") &&
                                !pruneTypo3AddedTags(element.content).startsWith("_MC_") &&
                                // this is the actual text on the page
                                    <div className="bodyText" 
                                        dangerouslySetInnerHTML={{__html: adjustListTags(processHtmlString((element.content)))}}  
                                    />
                                }
                            </div>

                            
                        </div>    
                    )
                })
                :
                    <div role="status">
                    {
                        //    Spinner
                    }
                        <svg aria-hidden="true" class="w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                        </svg>
                        <span class="sr-only">Loading...</span>
                    </div>                
                }
                </div>
                {!containsManuallySetButtons && (parseInt(routeParams.id) !== techIntroPageID && parseInt(routeParams.id) !== contentIntroPageID && parseInt(routeParams.id) !== erfahrenSieMehrPageID) &&
                    // navigation buttons
                    <div className="pageBottomButtonsWrapper contentElement">
                        <button className="btn pageBottomButtonLeft " onClick={navigateToPreviousPage}>Zurück</button>
                        <button className="btn pageBottomButtonRight ml-3" onClick={navigateToNextPage}>Weiter</button>
                    </div>
                }
            </div>
            }
            {(parseInt(routeParams.id) === techIntroPageID || parseInt(routeParams.id) === contentIntroPageID || parseInt(routeParams.id) === erfahrenSieMehrPageID) &&
                <Footer />
            }
            
        </div>
    )
}                    